module.exports = __webpack_public_path__ + "static/media/132.8f5439c0.png";